/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';
import Home from './components/Pages/Home';
import Appudvikling from './components/Pages/Appudvikling';
import Webudvikling from './components/Pages/Webudvikling';
import OmOs from './components/Pages/OmOs';
import Cases from './components/Pages/Cases';
import ScrollToTop from './ScrollToTop';

const theme = {
  mainColors: {
    hvid: '#F5F8FA',
    darkprpl: '#5271FF',
    prpl: '#AD63EB',
    darkblu: '#4e54c8',
    lightblu: '#119BD2',
    lightgreen: '#01C4B8',
    pink: '#CB6CE6',
    background: '#f5f8fa',
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ScrollToTop />
      <Routes>

        <Route path="/" element={<Home />}>
          Home Page
        </Route>

        <Route path="/appudvikling" element={<Appudvikling />}>
          Appudvikling
        </Route>

        <Route path="/webudvikling" element={<Webudvikling />}>
          Webudvikling
        </Route>

        <Route path="/kontakt" element={<OmOs />}>
          Om os
        </Route>

        <Route path="/cases" element={<Cases />}>
          Om os
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
